<template>
     <!-- 联系弹窗 -->
    <div class="ContactUs" v-if="ContactUsShow">
        <div class="ContactUs-content"> 
            <div class="ContactUs-title">
                <div class="tip-title">在线留言</div>
                <div> <span class="el-icon-close" @click="ContentStatus"></span> </div>
            </div>
            <div class="ContactUs-msg">
                <el-form ref="contactMsg" :inline="true" :model="contact_msg" :rules="contact_rules" class="" label-width="80px" label-position="top">
                    <el-form-item label="姓名" prop="userInfo.name" style="padding: 5px 20px 15px 0;">
                        <el-input v-model="contact_msg.userInfo.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" prop="userInfo.phone" style="padding: 5px 0px 15px 20px;">
                        <el-input v-model="contact_msg.userInfo.phone" placeholder="请输入电话" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="userInfo.mail" style="padding: 5px 20px 15px 0;">
                        <el-input v-model="contact_msg.userInfo.mail" placeholder="请输入邮箱"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="性别">
                        <el-input v-model="contact_msg.userInfo.sex" placeholder="请输入性别"></el-input>
                    </el-form-item>
                    <el-form-item label="QQ">
                        <el-input v-model="contact_msg.userInfo.QQ" placeholder="请输入QQ"></el-input>
                    </el-form-item>
                    <el-form-item label="地址">
                        <el-input v-model="contact_msg.userInfo.address" placeholder="请输入地址"></el-input>
                    </el-form-item> -->
                    <el-form-item label="留言内容" prop="question" style="width:100%;">
                        <el-input maxlength="300" show-word-limit type="textarea" v-model="contact_msg.question" :rows="6" style="width: 580px;" class="textarea-resize" resize="none"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="ContactUs-foot ">
                <el-button class="footBtn"  @click="vil_msg('contactMsg')" round>提交留言</el-button>
            </div>
        </div>
    </div>
</template>
 
<script>
// import {BASE_URL,PANRONG_URL} from "@/assets/js/IPconfig";
export default {
    name: "ContactUs",
    props:[],
    components:{
    },
    data() {
        return {
            ContactUsShow:false,
            contact_msg:{
                userInfo:{
                    name:"",
                    // sex:"",
                    phone:"",
                    // QQ:"",
                    // mail:"",
                    address:"",
                },
                question:"",
                receiveEmails:"info@decard.com",
                // receiveEmails:"cqq@decard.com",
            },
            contact_rules: {
                "userInfo.name": [
                    {required: true,  message: '请输入姓名', trigger: true},
                ],
                "userInfo.phone": [
                    { required: false, message: '请输入电话号码', trigger: false },
                    {message: '请输入正确的电话号码',  validator: validPhone }
                ],
                "userInfo.mail": [
                    { required: true,   message: '请输入邮箱', trigger: true},
                    { validator: checkEmail, message: '请输入正确的邮箱'}
                ],
                question: [
                    { required: true,  message: '请输入留言内容', trigger: true},
                ],
            }
        };
    },
    created(){

    },
    methods:{
        ContentStatus(){
            this.ContactUsShow = !this.ContactUsShow;
        },
        vil_msg(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.postmsg();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        postmsg(){
            let _this = this;
            let userInfo="",infoARR={ name:"姓名",phone:"电话",mail:"邮箱"};
            for(var key in this.contact_msg.userInfo){
                if(this.contact_msg.userInfo[key]!=""){
                    if(userInfo==""){
                        userInfo=`${infoARR[key]}:${this.contact_msg.userInfo[key]}`;
                    }else{
                        userInfo+=`,${infoARR[key]}:${this.contact_msg.userInfo[key]}`;
                    }
                }
            }
            $.ajax({
                url: `${window.$server_config.VUE_APP_WEBSITE_API}api/emailNotice/sendEmail`,
                type: 'POST',
                async: false,
                headers: {
                    "Access-Control-Allow-Origin":"*",
                    "Content-Type":"application/json;charset=UTF-8"
                },
                data:JSON.stringify({
                    receiveEmails:this.contact_msg.receiveEmails,
                    userInfo:userInfo,//JSON.stringify(this.contact_msg.userInfo)
                    question :this.contact_msg.question,
                }),
                success: function (result) {
                    if (result.code == 0) {
                        _this.ContentStatus();
                    }
                },
                error: function (result) {
                    _this.$message.error(result.msg);
                }
            })
        }

    },
    mounted() {

    },
}
//  电话验证
var validPhone=(rule, value,callback)=>{
    if (!value){
        // callback(new Error('请输入电话号码'))
        callback()
    }else  
    if (!isvalidPhone(value)){
    callback(new Error('请输入正确的11位手机号码'))
    }else {
        callback()
    }
};
var isvalidPhone = (str) =>{
    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
    return reg.test(str)
}

// 邮箱验证
var checkEmail = (rule, value, callback) => {
    const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
    if (!value) {
        // return callback(new Error('邮箱不能为空'))
        callback()
    }
    setTimeout(() => {
        if (mailReg.test(value)) {
            callback()
        } else {
            callback(new Error('请输入正确的邮箱格式'))
        }
    }, 100)
}
</script>

<style scoped lang="less">
    .ContactUs{
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background: rgba(0,0,0,0.8);
        border-radius: 2px;
        z-index:9999;
        .ContactUs-content{
            width: 660px;
            height: 536px;
            position: absolute;
            top: 50%;
            margin-top: -268px;
            left: 50%;
            margin-left: -330px;
            background: #fff;
            opacity: 1;
            padding: 32px 40px;
            border-radius: 4px;
            .ContactUs-title{
                // border-bottom:1px solid #ddd; 
                overflow: hidden;
                // height: 45px;
                // line-height: 45px;
                font-weight: 600;
                margin-bottom: 0px;
                &>div:nth-child(1){
                    float: left;
                    font-size: 20px;
                    color: #2C2C2C;
                    margin-bottom: 15px;
                }
                &>div:nth-child(2){
                    float: right;
                    font-weight: 24px;
                    color:#282828;
                    font-size: 20px;
                }
                .el-icon-close{
                    cursor: pointer;
                }
            }
            .ContactUs-msg{
                // height: 450px;
                .el-input--small{
                    // width: 290px;
                }
                .el-form-item{
                    margin:0;
                    width: 49.5%;
                    font-size: 14px;
                    color: #2C2C2C;
                }
            }
            .ContactUs-foot{
                text-align: center;
                margin-top: 38px;
                .footBtn{   
                    width: 176px;
                    height: 44px;
                    color: #fff;
                    background: #3BBDE7;
                    color: #fff;
                    font-size: 16px;
                }
                .footBtn:hover{ 
                    background: #22A6D1;
                 }
            }
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue